"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDetailsInfoItemValue = exports.StyledDetailsInfoItemLabel = exports.StyledDetailsInfoItem = exports.StyledDetailsInfoList = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDetailsInfoList = styled_components_1.default.ul `
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  flex: 1;
`;
exports.StyledDetailsInfoItem = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-start;
`;
exports.StyledDetailsInfoItemLabel = styled_components_1.default.div `
  font-size: 0.75rem;
  font-weight: 600;
  flex: 0 0 86px;

  padding: ${({ theme }) => theme.spacing(0.5)};
`;
exports.StyledDetailsInfoItemValue = styled_components_1.default.div `
  overflow-wrap: break-word; /* standard syntax */
  word-break: break-word; /* for compatibility */
  font-size: 0.75rem;
  padding: ${({ theme }) => theme.spacing(0.5)};
`;
